/** Cadencia de comprobación de sesión (ver research.md, Decisión 5 — margen holgado bajo SC-003, <10s). */
export const POLL_INTERVAL_MS = 3000

/** Espera tras un 'changed' antes de releer la cookie, para dar tiempo a que se propague. */
export const CHANGED_GRACE_DELAY_MS = 1500
